import React, { Component } from 'react';
import { connect } from 'react-redux';
import CustomerDetails from '../../components/CustomerDetails/CustomerDetails';
import { customerMessages, licenseMessages, surgeonMapping, loggerEventOutcome, loggerEventTypes, loggerEventName, careteamMapping, salesRepCustomerMapping } from '../../helpers/messages';
import {
    getCountryList, getCustomerDetailsService, getCareteamListResults, searchSurgeonsService, updateCustomerDetails, licenseListService, searchCareteamService,
    customerAssociatedSaleRepService, searchSalesRepService, getAllDevicesList
} from '../../services/java/java-services';
import { validateAlphanumeric, validateCity, validateCustomerFields, validatePhoneNumber } from './ValidateCustomer';
import { logger } from '../../services/logger/logger-service';
let startDate;

class CustomerDetailsContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            careTeamListloading: false,
            associateSalesRepLoading: false,
            deviceLoading: false,
            licenseListloading: false,
            careTeamError: false,
            deviceError: false,
            editMode: false,
            customerID: props.match.params.id || '',
            customerDetails: '',
            careteamList: '',
            salesrepList: '',
            deviceList: '',
            licenseList: '',
            searchResults: '',
            searchResultCareteam: '',
            searchResultSalesRep: '',
            showAddSurgeonModal: false,
            showAddLicenseModal: false,
            showAddCareteamModal: false,
            showAddSalesRepModal: false,
            refreshSurgeonList: false,
            disableSubmitBtn: false,
            licenseSuccessMsg: '',
            countryObj: [],
            stateObj: [],
            dialCodeObj: [],
            addressline1: '',
            addressline2: '',
            postalcode: '',
            customername: '',
            city: '',
            country: '',
            state: '',
            countrydialcode: '',
            phonenumber: '',
            vcmId:'',
            errors: {
                customername: '',
                addressline1: '',
                addressline2: '',
                postalcode: '',
                city: '',
                country: '',
                state: '',
                countrydialcode: '',
                phonenumber: '',
                vcmId:''
            },
            loggerObj: {
                "EventOutcome": loggerEventOutcome.success,
                "EventType": loggerEventTypes.read,
                "EventName": loggerEventName.customerDetails,
                "StartDate": new Date()
            },
            licenseError: null,
            customerError: null,
            customerSaveError: null,
            searchError: null,
            associatedSalesRepList: [],
            associateSalesRepError: null
        }
    }

    componentDidMount() {
        this.setState({ loading: true })
        this.getCountryList();
        this.getCareteamList();
        this.getAssociatedSalesRepList();
        this.getAllDevices();
        this.getLicenseDetails();
        // initialize the start date on page load
        startDate = new Date();
        window.addEventListener('beforeunload', this.applicationLogger);
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.applicationLogger);
        this.applicationLogger();
    }

    /**
     * @description function to handle application logs
     * @param {*}
     * @memberof CustomerDetailsContainer
     */
    applicationLogger(key) {
        // calculate the time since we loaded this page
        const timeSinceLoad = (new Date().getTime() - startDate.getTime()) / 1000;
        const loggerObj = {
            "EventOutcome": loggerEventOutcome.success,
            "EventType": loggerEventTypes.read,
            "EventName": loggerEventName.customerDetails,
            "Content": {
                "TimeSpent": timeSinceLoad
            }
        }
        logger(loggerObj);
    }

    /**
     * @description Function to get the country details
     * @memberof CustomerDetailsContainer
     */
    getCountryList = async () => {
        getCountryList((err, result) => {
            if (err) {
                this.setState({ loading: false })
            } else {
                const countryList = result.data && result.data.countryList && result.data.countryList.length ? result.data.countryList : [];
                this.setState({
                    countryObj: countryList
                });
                this.getCustomerDetails(this.state.customerID);
            }
        })
    }

    /**
     * @description Function to get the customer details
     * @param customerID Unique ID of the customer to be fetched
     * @memberof CustomerDetailsContainer
     */
    getCustomerDetails = async (customerID) => {
        this.setState({ loading: true })
        getCustomerDetailsService(customerID, (err, result) => {
            if (err) {
                this.setState({ loading: false, customerError: err })
            } else {
                const customer = result.data && result.data.user && result.data.user.length ? result.data.user[0] : '';
                this.handleInputChange('country', customer.country);
                this.setState({
                    loading: false,
                    customerError: null,
                    customerDetails: customer,
                    ...this.getEditObject(customer)
                });
            }
        })
    }

    /**
     * @description Function to get the customer associated careteam
     * @memberof CustomerDetailsContainer
     */
    getCareteamList = async () => {
        this.setState({ careTeamListloading: true });
        getCareteamListResults(this.state.customerID, (err, result) => {
            if (err) {
                this.setState({ careTeamListloading: false, careTeamError: err })
            } else {
                let careteamList = result.data.user ? result.data.user : [];
                this.setState({
                    careTeamListloading: false,
                    careTeamError: null,
                    careteamList
                });
            }
        })
    }

    /**
     * @description Function to get the customer associated sales rep
     * @memberof CustomerDetailsContainer
     */
    getAssociatedSalesRepList = async () => {
        this.setState({ associateSalesRepLoading: true });
        customerAssociatedSaleRepService(this.state.customerID, (err, result) => {
            if (err) {
                this.setState({ associateSalesRepLoading: false, associateSalesRepError: err })
            } else {
                let list = result.data ? result.data.SalesRepUserResponse : [];
                list = list.map(x => {
                    x['name'] = `${x.firstname} ${x.lastname}`
                    return x
                })
                this.setState({
                    associateSalesRepLoading: false,
                    associatedSalesRepList: list,
                    associateSalesRepError: null
                });
            }
        })
    }

    /**
     * @description Function to get the customer associated device
     * @memberof CustomerDetailsContainer
     */
    getAllDevices = async () => {
        this.setState({ deviceLoading: true });
        var urlParams = { customerId: this.state.customerID };
        getAllDevicesList(urlParams, (err, result) => {
            if (err) {
                this.setState({ deviceLoading: false, deviceError: err })
            } else {
                let deviceList = result.data.user ? result.data.user : [];
                this.setState({
                    deviceLoading: false,
                    deviceError: null,
                    deviceList
                });
            }
        });
    }

    /**
     * @description Function to get the license details
     * @memberof CustomerDetailsContainer
     */
    getLicenseDetails = async () => {
        this.setState({ licenseListloading: true });
        licenseListService(this.state.customerID, (err, result) => {
            if (err) {
                this.setState({ licenseListloading: false, licenseError: err })
            } else {
                const license = result.data.user ? result.data.user : [];
                this.setState({
                    licenseListloading: false,
                    licenseList: license,
                    licenseError: null
                });
            }
        })
    }

    /**
     * @description Function to handle state when edit is cancelled
     * @param customerDetails Customer Details
     * @memberof CustomerDetailsContainer
     */
    getEditObject(customerDetails) {
        this.setState({ customerSaveError: "" })
        const editObj = {
            customername: customerDetails ? customerDetails.customername : '',
            addressline1: customerDetails ? customerDetails.addressline1 : '',
            addressline2: customerDetails ? customerDetails.addressline2 : '',
            postalcode: customerDetails ? customerDetails.postalcode : '',
            country: customerDetails ? customerDetails.country : '',
            state: customerDetails ? customerDetails.state : '',
            countrydialcode: customerDetails ? customerDetails.countrycode : '',
            phonenumber: customerDetails ? customerDetails.phonenumber : '',
            city: customerDetails ? customerDetails.city : '',
            vcmId: customerDetails ? customerDetails.vcmId:''
        }
        return {
            editObj: editObj,
            ...editObj,
            errors: {
                customername: '',
                addressline1: '',
                addressline2: '',
                postalcode: '',
                country: '',
                state: '',
                countrydialcode: '',
                phonenumber: '',
                city: '',
                vcmId:''
            }
        }
    }

    /**
     * @description Function to enable/disable edit mode
     * @memberof CustomerDetailsContainer
     */
    toggleEditMode = () => {
        this.setState(prevState => {
            const editObj = this.getEditObject(prevState.customerDetails);
            return {
                ...editObj,
                dialCodeObj: [prevState.countryObj.find(cntry => cntry.countryname === (editObj.country)).dialcode],
                stateObj: prevState.countryObj.find(cntry => cntry.countryname === (editObj.country)).states,
                editMode: !prevState.editMode,
                disableSubmitBtn: true,
                showErrorMsg: ''
            };
        });
    }

    /**
     * @description Function to handle input changes
     * @param  value Value of the input
     * @param  field Input field name
     * @memberof CustomerDetailsContainer
     */
    handleInputChange = (field, value) => {
        var errorMessage = value ? '' : customerMessages[field];

        if (field === 'phonenumber' && value) {
            const phoneCheck = validatePhoneNumber(value);
            errorMessage = phoneCheck.error;
        }
        if (field === 'customername' && value) {
            const customerNameCheck = validateAlphanumeric(value);
            errorMessage = customerNameCheck.error;
        }
        if (field === 'addressline1' && value) {
            const addressline1Check = validateAlphanumeric(value);
            errorMessage = addressline1Check.error;
        }
        if (field === 'addressline2') {
            if (value) {
                const addressline2Check = validateAlphanumeric(value);
                errorMessage = addressline2Check.error;
            } else {
                errorMessage = ''
            }
        }
        if (field === 'postalcode' && value) {
            const postalcodeCheck = validateAlphanumeric(value);
            errorMessage = postalcodeCheck.error;
        }

        if (field === 'city' && value) {
            const cityNameCheck = validateCity(value);
            errorMessage = cityNameCheck.error;
        }
        if (field === 'vcmId') {
            if (value) {
                const vcmIdCheck = validateAlphanumeric(value);
                errorMessage = vcmIdCheck.error;
            } else {
                errorMessage = ''
            }
        }

        if (field === 'country' && value) {
            this.setState({ stateObj: [], dialCodeObj: [], state: '', countrydialcode: '' });
            this.setState({ dialCodeObj: [this.state.countryObj.find(cntry => cntry.countryname === (value)).dialcode] });
            this.setState({ stateObj: this.state.countryObj.find(cntry => cntry.countryname === (value)).states });
        } else if (field === 'country' && value === '') {
            this.setState({ stateObj: [], dialCodeObj: [], state: '', countrydialcode: '' })
        }
        this.setState(prevState => {
            return {
                [field]: value,
                editObj: {
                    ...prevState.editObj,
                    [field]: value
                },
                errors: {
                    ...prevState.errors,
                    [field]: errorMessage
                }
            }
        });

        setTimeout(() => {
            this.setSubmitDisabledState();
        }, 0);
    }

    /** 
     * @description Function determine if any field has been changed
     *  @memberof CustomerDetailsContainer
     */
    setSubmitDisabledState = () => {
        const { editObj, customerDetails } = this.state;
        const noFieldsChanged = editObj.customername === customerDetails.customername && editObj.addressline1 === customerDetails.addressline1 &&
            editObj.addressline2 === customerDetails.addressline2 && editObj.postalcode === customerDetails.postalcode && editObj.country === customerDetails.country &&
            editObj.state === customerDetails.state && editObj.countrydialcode === customerDetails.countrycode && editObj.phonenumber === customerDetails.phonenumber
            && editObj.city === customerDetails.city && editObj.vcmId === customerDetails.vcmId;

        this.setState({
            disableSubmitBtn: noFieldsChanged
        })
    }

    /** 
     * @description Function submit form by hitting enter key
     *  @param e Keypress event
     *  @memberof CustomerDetailsContainer
     */
    onEnterPress = (e) => {
        if (e.which === 13) {
            e.preventDefault();
            this.saveCustomer();
        }
    }

    /**
     * @description Function to validate fields at the time of submit
     * @returns Boolean value if there are any errors
     * @memberof CustomerDetailsContainer
     */
    validateFields = () => {
        let { errorFlag, errors } = validateCustomerFields(this.state);
        if (!errorFlag && this.state.customername) {
            let customername = validateAlphanumeric(this.state.customername);
            errorFlag = customername.errorFlag;
            errors['customername'] = customername.error;
        }
        if (!errorFlag && this.state.addressline1) {
            let addressline1 = validateAlphanumeric(this.state.addressline1);
            errorFlag = addressline1.errorFlag;
            errors['addressline1'] = addressline1.error;
        }
        if (!errorFlag && this.state.addressline2) {
            let addressline2 = validateAlphanumeric(this.state.addressline2);
            errorFlag = addressline2.errorFlag;
            errors['addressline2'] = addressline2.error;
        }
        if (!errorFlag && this.state.postalcode) {
            let postalcode = validateAlphanumeric(this.state.postalcode);
            errorFlag = postalcode.errorFlag;
            errors['postalcode'] = postalcode.error;
        }
        if (!errorFlag && this.state.phonenumber) {
            let phonenumber = validatePhoneNumber(this.state.phonenumber);
            errorFlag = phonenumber.errorFlag;
            errors['phonenumber'] = phonenumber.error;
        }
        if (!errorFlag && this.state.city) {
            let cityName = validateCity(this.state.city);
            errorFlag = cityName.errorFlag;
            errors['city'] = cityName.error;
        }
        if (!errorFlag && this.state.vcmId) {
            let vcmId = validateAlphanumeric(this.state.vcmId);
            errorFlag = vcmId.errorFlag;
            errors['vcmId'] = vcmId.error;
        }
        if (errorFlag) {
            this.setState(prevState => {
                return {
                    errors: {
                        ...prevState.errors,
                        ...errors
                    }
                }
            })
        }

        return errorFlag;
    }

    /**
     * @description function to validate and save the case details
     * @param {*}
     * @memberof CustomerDetailsContainer
     */
    saveCustomer = () => {
        this.setState({ showSuccessMsg: '', showErrorMsg: '' });
        const formHasErrors = this.validateFields();

        if (!formHasErrors) {
            this.setState({ isLoading: true });
            const { country, state, countrydialcode, addressline1, addressline2, postalcode, phonenumber, city, customername,vcmId } = this.state;
            const getCustomerDetails = {
                "customername": customername.trim(),
                "country": country,
                "state": state,
                "countrydialcode": countrydialcode,
                "addressline1": addressline1.trim(),
                "addressline2": addressline2?.trim(),
                "postalcode": postalcode,
                "phonenumber": phonenumber,
                "city": city.trim(),
                "vcmId":vcmId?.trim()
            }
            updateCustomerDetails(this.state.customerDetails.customerid, getCustomerDetails, (err, result) => {
                if (err) {
                    let duplicateFieldName = '';
                    let duplicateFieldMsg = '';
                    let showErrorMsg = '';
                    switch (err.errorCode) {
                        case 2022:
                            duplicateFieldName = 'customername';
                            duplicateFieldMsg = 'duplicateCustomerName';
                            showErrorMsg = customerMessages['duplicateProfile'];
                            break;
                        case 2023:
                            duplicateFieldName = 'addressline1';
                            duplicateFieldMsg = 'duplicateAddress';
                            showErrorMsg = customerMessages['duplicateProfile'];
                            break;
                        case 2024:
                            duplicateFieldName = 'phonenumber';
                            duplicateFieldMsg = 'duplicatePhoneNumber';
                            showErrorMsg = customerMessages['duplicateProfile'];
                            break;

                        default:
                            showErrorMsg = err.message;
                            break;
                    }

                    this.setState(prevState => {
                        return {
                            showErrorMsg: showErrorMsg,
                            isLoading: false,
                            customerSaveError: {
                                ...err,
                                message: showErrorMsg
                            },
                            errors: {
                                ...prevState.errors,
                                [duplicateFieldName]: customerMessages[duplicateFieldMsg]
                            }
                        }
                    });
                } else {
                    this.setState({ showSuccessMsg: customerMessages['saveCustomerMsg'], isLoading: false, editMode: false, showErrorMsg: '', customerSaveError: null });
                    const getCustomerId = result.data && result.data.customerId ? result.data.customerId : '';
                    this.getCustomerDetails(getCustomerId);
                    setTimeout(() => {
                        this.setState({ showSuccessMsg: '' });
                    }, 10000);
                }
            })
        }
    }

    /**
     * @description function to handle input changes..
     * @param  {} inputType
     * @memberof CustomerDetailsContainer
     */
    handleSearchInputChange = async (inputValue) => {
        var errors = { ...this.state.errors }
        errors.searchKey = '';
        this.setState({ errors })
        this.setState({ searchKey: inputValue.trim() });
    }

    /** @description function to find surgeons
     *  @param  {}
     *  @memberof CustomerDetailsContainer
     */
    findSurgeons = async () => {
        var errors = { ...this.state.errors }
        if (this.state.searchKey.trim() === '') {
            errors.searchKey = surgeonMapping.emptySearchBox;
            this.setState({ errors })
            return errors;
        } else {
            errors.searchKey = '';
            this.setState({ errors })
        }
        await this.getSearchResults(this.state.searchKey);
    }

    /** @description function to find careteam
     *  @param  {}
     *  @memberof CustomerDetailsContainer
     */
    findCareTeam = async () => {
        var errors = { ...this.state.errors }
        if (this.state.searchKey.trim() === '') {
            errors.searchKey = careteamMapping.emptySearchBox;
            this.setState({ errors })
            return errors;
        } else {
            errors.searchKey = '';
            this.setState({ errors })
        }
        await this.getCareteamResults(this.state.searchKey);
    }

    /** @description function to find salesrep
     *  @param  {}
     *  @memberof CustomerDetailsContainer
     */
    findSalesRep = async () => {
        var errors = { ...this.state.errors }
        if (this.state.searchKey.trim() === '') {
            errors.searchKey = salesRepCustomerMapping.emptySearchBox;
            this.setState({ errors })
            return errors;
        } else {
            errors.searchKey = '';
            this.setState({ errors })
        }
        await this.getSalesRepResults(this.state.searchKey);
    }

    /** @description function to search surgeons and careteam by clicking on enter
    *  @param e Keyup event object
    *  @param section The section for which we are doing the search
    *  @memberof CustomerDetailsContainer
    */
    onSearchEnterPress = (e, section) => {
        if (e.which === 13) {
            switch (section) {
                case 'surgeon':
                    this.findSurgeons();
                    break;
                case 'careteam':
                    this.findCareTeam();
                    break;
                case 'salesrep':
                    this.findSalesRep();
                    break;

                default:
                    break;
            }
        }
    }

    /**
    * @description function to get surgeons list based on search inputs 
    * @param {*}
    * @memberof CustomerDetailsContainer
    */
    getSearchResults = async (searchKey) => {
        this.setState({ loading: true, searchResults: '' })
        let params = {
            searchString: searchKey,
            customerId: this.state.customerID
        }
        searchSurgeonsService(params, (err, result) => {
            if (err) {
                this.setState({ loading: false, searchError: err })
            } else {
                const surgeonList = result.data && result.data.user && result.data.user.length && result.data.user[0].surgeonList ? result.data.user[0].surgeonList : [];
                this.setState({ loading: false, searchResults: surgeonList, searchError: null });
            }
        })
    }

    /**
    * @description function to get careteam list based on search inputs 
    * @param {*}
    * @memberof CustomerDetailsContainer
    */
    getCareteamResults = async (searchKey) => {
        this.setState({ loading: true, searchResultCareteam: '' })
        let params = {
            searchString: searchKey,
            customerId: this.state.customerID
        }
        searchCareteamService(params, (err, result) => {
            if (err) {
                this.setState({ loading: false, searchError: err })
            } else {
                const careTeamList = result.data && result.data.user && result.data.user.length && result.data.user[0].careTeamList ? result.data.user[0].careTeamList : [];
                this.setState({ loading: false, searchResultCareteam: careTeamList, searchError: null });
            }
        })
    }

    /**
     * @description function to get salesrep list based on search inputs 
     * @param {*}
     * @memberof CustomerDetailsContainer
    */
    getSalesRepResults = async (searchKey) => {
        this.setState({ loading: true, searchResultSalesRep: '' });
        let params = {
            searchString: searchKey,
            customerId: this.state.customerID
        }
        searchSalesRepService(params, (err, result) => {
            if (err) {
                this.setState({ loading: false, searchError: err });
            } else {
                const salesRepList = result?.data?.salesrepList || [];
                this.setState({
                    loading: false,
                    searchResultSalesRep: salesRepList,
                    searchError: null
                });
            }
        });

    }

    /**
     * @description function to open and close modal popup 
     * @param {*}
     * @memberof CustomerDetailsContainer
     */
    enableAddSurgeonModal = () => {
        const { showAddSurgeonModal } = this.state;
        this.setState({
            refreshSurgeonList: false,
            showAddSurgeonModal: !showAddSurgeonModal
        });
        this.clearSearch();
    }

    /**
     * @description function to open and close modal popup for care team 
     * @param {*}
     * @memberof CustomerDetailsContainer
     */
    enableCareTeamModal = () => {
        const { showAddCareteamModal } = this.state;
        this.setState({
            refreshSurgeonList: false,
            showAddCareteamModal: !showAddCareteamModal
        });
        this.clearSearch();
    }

    /**
     * @description function to open and close modal popup for sales rep 
     * @param {*}
     * @memberof CustomerDetailsContainer
     */
    enableSalesRepModal = () => {
        const { showAddSalesRepModal } = this.state;
        this.setState({
            refreshSurgeonList: false,
            showAddSalesRepModal: !showAddSalesRepModal
        });
        this.clearSearch();
    }

    /**
     * @description function to open and close modal popup  for new license
     * @param {*}
     * @memberof CustomerDetailsContainer
     */
    enableAddLicenseModal = () => {
        const { showAddLicenseModal } = this.state;
        this.setState({
            refreshSurgeonList: false,
            showAddLicenseModal: !showAddLicenseModal
        });
        this.clearSearch();
    }

    /**
     * @description function to open clear search results 
     * @param {*}
     * @memberof CustomerDetailsContainer
     */
    clearSearch = () => {
        var errors = { ...this.state.errors }
        errors.searchKey = '';
        this.setState({ searchResults: '', searchKey: '', errors, searchResultCareteam: '', searchResultSalesRep: '' })
    }

    /**
    * @description function to refresh surgeon list
    * @param {*}
    * @memberof CustomerDetailsContainer
    */
    refreshDataList = (status) => {
        this.setState({ refreshSurgeonList: status });
        if (status) {
            this.getCustomerDetails(this.state.customerID);
        }
    }

    /**
    * @description function to refresh license list
    * @param {*}
    * @memberof CustomerDetailsContainer
    */
    refreshLicenseDataList = (status, operation = 'save') => {
        this.setState({ refreshSurgeonList: status });
        if (status) {
            this.getLicenseDetails();
            if (operation === 'save') {
                this.setState({ licenseSuccessMsg: licenseMessages['saveLicenseMsg'] });
                setTimeout(() => {
                    this.setState({ licenseSuccessMsg: '' });
                }, 5000);
            }
        }
    }

    /**
    * @description function to refresh surgeon list
    * @param {*}
    * @memberof CustomerDetailsContainer
    */
    refreshSurgeon = (status) => {
        if (status) {
            this.getCustomerDetails(this.state.customerID);
        }
    }

    /**
    * @description function to refresh careteam list
    * @param {*}
    * @memberof CustomerDetailsContainer
    */
    refreshCareteamList = (status) => {
        this.setState({ refreshSurgeonList: status });
        if (status) {
            this.getCareteamList();
        }
    }

    /**
    * @description function to refresh salesrep list
    * @param {*}
    * @memberof CustomerDetailsContainer
    */
    refreshSalesRepList = (status) => {
        this.setState({ refreshSurgeonList: status });
        if (status) {
            this.getAssociatedSalesRepList();
        }
    }

    /**
    * @description function to refresh device list
    * @param {*}
    * @memberof CustomerDetailsContainer
    */
    refreshDeviceList = (status) => {
        this.setState({ refreshSurgeonList: status });
        if (status) {
            this.getAllDevices();
        }
    }

    render() {
        return (
            <CustomerDetails
                loading={this.state.loading}
                licenseListloading={this.state.licenseListloading}
                customer={this.state.customerDetails}
                customerError={this.state.customerError}
                editMode={this.state.editMode}
                editObj={this.state.editObj}
                formErrors={this.state.errors}
                resetStates={this.state.resetStates}
                countryObj={this.state.countryObj}
                stateObj={this.state.stateObj}
                dialCodeObj={this.state.dialCodeObj}
                country={this.state.country}
                custState={this.state.state}
                countrydialcode={this.state.countrydialcode}
                showErrorMsg={this.state.showErrorMsg}
                showSuccessMsg={this.state.showSuccessMsg}
                disableSubmitBtn={this.state.disableSubmitBtn}
                toggleEditMode={this.toggleEditMode}
                handleInputChange={this.handleInputChange}
                onEnterPress={this.onEnterPress}
                saveCustomer={this.saveCustomer}
                searchResults={this.state.searchResults}
                searchResultCareteam={this.state.searchResultCareteam}
                searchResultSalesRep={this.state.searchResultSalesRep}
                enableAddSurgeonModal={this.enableAddSurgeonModal}
                enableCareTeamModal={this.enableCareTeamModal}
                enableSalesRepModal={this.enableSalesRepModal}
                showAddSurgeonModal={this.state.showAddSurgeonModal}
                isLoading={this.state.loading}
                handleSearchInputChange={this.handleSearchInputChange}
                findSurgeons={this.findSurgeons}
                refreshSurgeonList={this.state.refreshSurgeonList}
                refreshDataList={this.refreshDataList}
                refreshLicenseDataList={this.refreshLicenseDataList}
                licenseSuccessMsg={this.state.licenseSuccessMsg}
                onSearchEnterPress={this.onSearchEnterPress}
                refreshSurgeon={this.refreshSurgeon}
                loggerObj={this.state.loggerObj}
                enableAddLicenseModal={this.enableAddLicenseModal}
                showAddLicenseModal={this.state.showAddLicenseModal}
                showAddCareteamModal={this.state.showAddCareteamModal}
                showAddSalesRepModal={this.state.showAddSalesRepModal}
                licenseList={this.state.licenseList}
                licenseError={this.state.licenseError}
                customerSaveError={this.state.customerSaveError}
                searchError={this.state.searchError}
                findCareTeam={this.findCareTeam}
                findSalesRep={this.findSalesRep}
                careTeamListloading={this.state.careTeamListloading}
                careTeamError={this.state.careTeamError}
                refreshCareteamList={this.refreshCareteamList}
                refreshSalesRepList={this.refreshSalesRepList}
                careteamList={this.state.careteamList}
                associatedSalesRepList={this.state.associatedSalesRepList}
                associateSalesRepError={this.state.associateSalesRepError}
                associateSalesRepLoading={this.state.associateSalesRepLoading}
                deviceLoading={this.state.deviceLoading}
                deviceError={this.state.deviceError}
                deviceList={this.state.deviceList}
                refreshDeviceList={this.refreshDeviceList}
            />
        );
    }
}

function mapStateToProps(state) {
    return {
        state,
    };
}

export default connect(mapStateToProps)(CustomerDetailsContainer);